import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { pmApi } from '../../lib/pmApi';

const PmPropertyHistory = () => {
  const [events, setEvents] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [propMap, setPropMap] = useState({});

  useEffect(() => {
    Promise.all([
      pmApi.serviceHistory(),
      pmApi.invoices(),
      pmApi.properties(),
    ]).then(([evs, invs, props]) => {
      setEvents(evs || []);
      setInvoices(invs || []);
      const m = {};
      (props || []).forEach((p) => { m[p.id] = p; });
      setPropMap(m);
    }).catch(() => {});
  }, []);

  // group by property — completed work events + invoices
  const byProperty = {};
  events.forEach((e) => {
    const pid = e.property_id || 'unknown';
    byProperty[pid] = byProperty[pid] || { events: [], invoices: [], name: e.property_name };
    byProperty[pid].events.push(e);
  });
  invoices.forEach((inv) => {
    if (!inv.property_id) return;
    byProperty[inv.property_id] = byProperty[inv.property_id] || { events: [], invoices: [], name: inv.property_name };
    byProperty[inv.property_id].invoices.push(inv);
  });

  return (
    <div data-testid="pm-history-page" className="p-6 max-w-6xl space-y-6">
      <div>
        <p className="text-[#D4AF37] text-xs font-bold tracking-[0.3em] mb-1">PROPERTY HISTORY</p>
        <h1 className="font-['Outfit'] text-3xl font-bold text-white">Completed Work &amp; Invoices</h1>
      </div>
      {Object.entries(byProperty).length === 0 && (
        <p data-testid="pm-history-empty" className="text-[#525252]">No completed work yet.</p>
      )}
      {Object.entries(byProperty).map(([pid, data]) => {
        const prop = propMap[pid] || { name: data.name || pid };
        return (
          <div key={pid} data-testid={`pm-history-${pid}`} className="bg-[#141414] border border-[#262626] rounded-md overflow-hidden">
            <div className="px-5 py-3 border-b border-[#262626] flex items-center justify-between">
              <Link to={`/pm/properties/${pid}`} className="text-white font-medium hover:text-[#D4AF37]">{prop.name || data.name || pid}</Link>
              <p className="text-[#525252] text-xs">{data.events.length} completed · {data.invoices.length} invoice(s)</p>
            </div>
            <div className="grid md:grid-cols-2 divide-x divide-[#262626]">
              <div className="p-4">
                <p className="text-[10px] text-[#525252] tracking-widest font-bold mb-3">COMPLETED WORK</p>
                {data.events.map((e) => (
                  <div key={e.id} data-testid={`pm-history-event-${e.id}`} className="py-2 border-b border-[#1f1f1f] last:border-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      {e.work_order_number && <span className="text-[#D4AF37] font-mono text-xs">{e.work_order_number}</span>}
                      <span className="text-white text-sm">{e.service_type || 'Service'}</span>
                      {e.service_date && <span className="text-[#525252] text-xs">· {e.service_date}</span>}
                    </div>
                    {e.requester_name && (
                      <p className="text-cyan-300 text-xs mt-0.5">Requested by: {e.requester_state === 'unknown' ? 'Unknown' : e.requester_name}</p>
                    )}
                    {e.work_performed && <p className="text-[#A3A3A3] text-xs mt-0.5">{e.work_performed.slice(0, 90)}</p>}
                  </div>
                ))}
                {data.events.length === 0 && <p className="text-[#525252] text-xs">No completed work.</p>}
              </div>
              <div className="p-4">
                <p className="text-[10px] text-[#525252] tracking-widest font-bold mb-3">INVOICES</p>
                {data.invoices.map((inv) => (
                  <div key={inv.id} className="flex justify-between text-sm py-1.5">
                    <span className="text-[#D4AF37] font-mono text-xs">{inv.invoice_number}</span>
                    <span className="text-white">${Number(inv.total || 0).toLocaleString()}</span>
                  </div>
                ))}
                {data.invoices.length === 0 && <p className="text-[#525252] text-xs">No invoices.</p>}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PmPropertyHistory;
